import { SignOutRegular } from "@fluentui/react-icons";

function Logout({ onLogout }: { onLogout: () => void }) {
  return (
    <div
      className="shadow-x flex cursor-pointer items-center justify-center border-l-2 py-4 pl-5 pr-4"
      onClick={onLogout}
    >
      <SignOutRegular fontSize={20} />
    </div>
  );
}

export default Logout;
